import { XmarkCircle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconXmarkCircle12Line = createIcon(XmarkCircle, 12, "Line");
export const IconXmarkCircle16Line = createIcon(XmarkCircle, 16, "Line");
export const IconXmarkCircle20Line = createIcon(XmarkCircle, 20, "Line");
export const IconXmarkCircle24Line = createIcon(XmarkCircle, 24, "Line");
export const IconXmarkCircle32Line = createIcon(XmarkCircle, 32, "Line");
export const IconXmarkCircle48Line = createIcon(XmarkCircle, 48, "Line");
export const IconXmarkCircle64Line = createIcon(XmarkCircle, 64, "Line");
